import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_CARD } from '@progress/kendo-angular-layout';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { AgenciesClient, AgencyDetailedDto } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { GridcellCurrencySharedComponent } from '@unity/shared/presentation/gridcell-currency-shared/gridcell-currency-shared.component';
import { LinkGridcellSharedComponent } from '@unity/shared/presentation/link-gridcell-shared/link-gridcell-shared.component';
@Component({
  selector: 'unity-grid-agency-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    KENDO_CARD,
    KENDO_DROPDOWNBUTTON,
    GridSharedComponent,
    GridcellCurrencySharedComponent,
    ChipWorkflowStateSharedComponent,
    LinkGridcellSharedComponent,
    TypedDirective,
  ],
  templateUrl: './grid-agency-shared.component.html',
  styleUrl: './grid-agency-shared.component.scss',
})
export class GridAgencySharedComponent extends AbstractGridComponent<AgencyDetailedDto> {
  private readonly agenciesClient = inject(AgenciesClient);

  protected override resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      return query ? { query } : undefined;
    },
    stream: ({ params: { query } }) => this.agenciesClient.getAllAsDetailed(query.page, query.pageSize, query.orderBy, query.filter),
  });
}
